import { GanttTaskStatus, GanttZoomLevel } from './gantt-types';

export const GANTT_DEFAULT_SECTION_LABEL = 'Timeline';

export const GANTT_STATUS_COLORS: Record<GanttTaskStatus, string> = {
  [GanttTaskStatus.None]: '#5B9EFF',
  [GanttTaskStatus.Done]: '#64748B',
  [GanttTaskStatus.Active]: '#66FEC1',
  [GanttTaskStatus.Crit]: '#F29F57',
  [GanttTaskStatus.Milestone]: '#A78BFA',
};

export const GANTT_STATUS_LABEL: Record<GanttTaskStatus, string> = {
  [GanttTaskStatus.None]: 'Planned',
  [GanttTaskStatus.Done]: 'Done',
  [GanttTaskStatus.Active]: 'Active',
  [GanttTaskStatus.Crit]: 'Critical',
  [GanttTaskStatus.Milestone]: 'Milestone',
};

export const LABEL_COLUMN_WIDTH = 130;
export const AXIS_HEIGHT = 40;
export const ROW_HEIGHT = 36;
export const SECTION_ROW_HEIGHT = 30;
export const BAR_HEIGHT = 22;
export const BAR_RADIUS = 4;
export const MILESTONE_SIZE = 12;

export const TIMELINE_LEFT_PADDING = 12;
export const TIMELINE_RIGHT_PADDING = 36;
export const CHART_VERTICAL_PADDING = 16;

export const MAX_CONTAINER_HEIGHT = 520;
export const MIN_CONTAINER_HEIGHT = 220;

export const DIMMED_OPACITY = 0.25;
export const HOVER_TRANSITION = 'opacity 150ms ease-out, filter 150ms ease-out';

export const TOOLTIP_BACKGROUND = 'rgba(12, 16, 24, 0.98)';
export const TOOLTIP_BORDER = '1px solid rgba(255, 255, 255, 0.08)';

export const TODAY_COLOR = '#66FEC1';
export const TODAY_STROKE_DASH = '4 3';

export const PX_PER_DAY_BY_ZOOM: Record<GanttZoomLevel, number> = {
  [GanttZoomLevel.Day]: 24,
  [GanttZoomLevel.Week]: 10,
  [GanttZoomLevel.Month]: 3,
};

// Continuous-zoom bounds (px-per-day). The lower bound keeps very long ranges
// from collapsing to a single column; the upper bound prevents an over-zoomed
// chart where a single day takes most of the viewport.
export const MIN_PX_PER_DAY = 0.3;
export const MAX_PX_PER_DAY = 80;
export const ZOOM_STEP = 1.4;
// Wheel-driven pinch-zoom sensitivity. exp(-deltaY * sensitivity) is the
// per-event scale factor, anchored on the cursor position.
export const PINCH_ZOOM_SENSITIVITY = 0.012;
// Below these px-per-day thresholds the axis switches granularity.
export const PX_PER_DAY_DAY_THRESHOLD = 14;
export const PX_PER_DAY_WEEK_THRESHOLD = 3.5;

export const TITLE_ROW_HEIGHT = 40;
export const TOOLBAR_HEIGHT = 44;

export const SCROLL_FADE_WIDTH_PX = 24;
export const SCROLL_FADE_COLOR = 'rgba(15, 19, 29, 0.95)';
